export const stringifyDate = (date, { withDate = true, withTime = true } = {}) => {
  return new Date(date).toLocaleString('ru-RU', {
    ...(withDate && { day: 'numeric', month: 'numeric', year: 'numeric' }),
    ...(withTime && { hour: '2-digit', minute: '2-digit', hour12: false }),
  });
};
